document.addEventListener("alpine:init", () => {
    Alpine.data("flowpaper", () => ({
        isOpened: false,
        url: false,
        init() {
            console.log('Flowpaper init', this.isOpened, this.url);
        },
        open(url) {
            this.url = url;
            this.isOpened = true;
            console.log('Flowpaper open', this.isOpened, this.url);
        },
        close() {
            this.isOpened = false;
            console.log('Flowpaper close');
        },
    }));
});
